import {
	Component,
	OnInit,
	Input,
	SimpleChange,
	OnChanges,
} from "@angular/core";
import { StateSpecificContentModelService } from "../../models/state-specific-content-model.service";
import { CoursePage } from "../../vo/course-page";
import { Subscription } from "rxjs";
import { ModalPopupService } from "../../../services/modal-popup.service";
import { DescriptorModelService } from "../../models/descriptor-model.service";
import { AppServices } from "app/app.services";
import { ConfigDocModelService } from "app/core/models/config-doc-model.service";

import { UtilityScripts } from "../../../helpers/utility-scripts";

@Component({
	selector: "app-state-specific-content",
	templateUrl: "./state-specific-content.component.html",
	styleUrls: ["./state-specific-content.component.css"],
})
export class StateSpecificContentComponent {
	public descriptorService: DescriptorModelService;
	private thumbnailImg: string;
	private serviceSubsriber: Subscription;
	private bShowPopup: boolean;
	protected _state_content: any;
	protected bShowStateSpecificIcon: boolean;
	@Input() coursePage: CoursePage;
	constructor(
		private stateContentModel: StateSpecificContentModelService,
		private configDocModel: ConfigDocModelService,
		private modalPopupService: ModalPopupService,
		private descriptorModel: DescriptorModelService,
		private appService: AppServices
	) {}

	public ngOnChanges(changes: SimpleChange) {
		if (
			changes.hasOwnProperty("coursePage") &&
			changes["coursePage"]["currentValue"] !== undefined
		) {
			//this.updateStateContent();
			//this.serviceSubsriber = this.stateContentModel.notifier.subscribe(data => this.updateStateContent())
		}
	}
	private updateStateContent() {
		if (this.serviceSubsriber) {
			this.serviceSubsriber.unsubscribe();
		}
		if (
			this.configDocModel.isStateSpecificContentPresent &&
			this.coursePage.state_specific_content !== "false" &&
			this.coursePage.state_specific_content !== ""
		) {
			this.stateContentModel.updateStateContent(
				this.coursePage.state_specific_content
			);
		}
	}
	private clickHandler() {
		let strBody: string = "";
		let clickStateId: string = "";
		this.state_content.content.forEach((element) => {
			if (element.heading !== "&nbsp;") {
				strBody += "<h4> <b>" + element.heading + "</b> </h4> ";
			}
			strBody += element.content;
			clickStateId = element.id;
		});

		let popupdata: any = {
			size: "lg",
			showClose: true,
			buttonLabel: this.descriptorModel.getDescriptorTextById("close_str"),
			title: this.state_content.selected_state_label,
			bodyText: strBody,
		};
		this.modalPopupService.openPopup(popupdata);
		this.appService.stateSpecificButtonClickHandler(
			this.coursePage.state_specific_content
		);
		this.stateContentModel.updateStateContent(clickStateId);
		/* this.stateContentModel.updateStateContent(clickStateId, '_visited'); */
	}
	private closeHandler() {
		this.bShowPopup = false;
	}
	public get state_content() {
		return (this._state_content = this.stateContentModel.stateContent);
	}
	public set state_content(val: any) {
		this._state_content = this.stateContentModel.stateContent = val;
	}
	public get showStateSpecificIcon() {
		return (this.bShowStateSpecificIcon =
			this.stateContentModel.bShowStateSpecificIcon);
	}
	public set showStateSpecificIcon(val: boolean) {
		this.bShowStateSpecificIcon =
			this.stateContentModel.bShowStateSpecificIcon = val;
	}
	public get state_label(): string {
		return this.descriptorModel.getDescriptorTextById("stateClick")
			? this.descriptorModel.getDescriptorTextById("stateClick")
			: "Click Here for Additional Required Information";
	}
}
